import axios from 'axios'
import { Loading,Message } from 'element-ui';

const http = axios.create({
	baseURL: process.env.VUE_APP_BASE_API2,
	timeout: 1000 * 600,
	withCredentials: true
})
let  loading=null;
/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	let accessToken = sessionStorage.getItem("accessToken") ||localStorage.getItem("accessToken");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
	}
	/*loading = Loading.service({
		lock: true,
		text: '...',
		spinner: 'el-icon-loading',
		background: 'rgba(0, 0, 0, 0.7)'
	});*/
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	if (response.data.code == 200) {
		return response.data;
	} else if (response.data.code == 400) {
		location.href = "/";
	}  else {
		console.log("response",response)
		if(Object.prototype.toString.call(response.data) === '[object Blob]') return response.data;
		if(response.data && response.data.msg.includes('IMSessionInfo')){
			 	window.$showLogin({
				success: () => {},
				cancel: () =>{
					console.log("登录cancel")
				}
			});
			return Promise.reject(response.data)
		}
		Message({
			message: response.data.msg,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, error => {
	console.log("error",error)
	if(!error.response){
		Message({
			message: error.message,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(error)
	}
	switch (error.response.status) {
		case 400:
			Message({
				message: error.response.data,
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 401:
			location.href = "/";
			break
		case 405:
			Message({
				message: 'http请求方式有误',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 404:
		case 500:
			Message({
				message: '服务器出了点小差，请稍后再试',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 501:
			Message({
				message: '服务器不支持当前请求所需要的某个功能',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
	}

	return Promise.reject(error)
})


export default http
